var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.myConfig.items),function(item,index){return _c('Formcard',{directives:[{name:"show",rawName:"v-show",value:(_vm.headList[item.name]),expression:"headList[item.name]"}],key:item.name,ref:item.name,refInFor:true,attrs:{"id":item.name,"config":item,"dictData":_vm.dictData},on:{"doAction":_vm.doAction}})}),1)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/masterplate/formcardgroupbox.vue